import React from 'react';
import { MIN_DESKTOP_WIDTH, MAX_MEDIUM_SIZE } from 'constants/misc';

function withResponsive(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        isMobile: window.innerWidth < MIN_DESKTOP_WIDTH,
        isMedium: window.innerWidth > MIN_DESKTOP_WIDTH &&
          window.innerWidth < MAX_MEDIUM_SIZE,
      };
    }

    componentWillMount() {
      window.addEventListener('resize', this.handleResize);
    }
    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }

    handleResize = () => {
      this.setState({
        isMobile: window.innerWidth < MIN_DESKTOP_WIDTH,
        isMedium: window.innerWidth > MIN_DESKTOP_WIDTH &&
          window.innerWidth < MAX_MEDIUM_SIZE,
      });
    }

    render() {
      return (
        <WrappedComponent
          isMobile={this.state.isMobile}
          isMedium={this.state.isMedium}
          {...this.props}
        />
      );
    }
  };
}

export default withResponsive;
